import { createFileRoute } from '@tanstack/react-router'
import FocusedLoop from '@/modules/content/loop/FocusedLoop'

// The primary consumption surface. Every card in the feed and in search opens here,
// anchored at the tapped item, and it is what a shared post or video link resolves to.
const LoopPage = () => {
  const { contentId } = Route.useParams()
  const { source } = Route.useSearch()

  // Remount the loop when the anchor changes so a new deep link starts a fresh focused
  // session (and a fresh telemetry session id) instead of reusing the previous stream.
  return <FocusedLoop key={`${source}-${contentId}`} anchorId={contentId} source={source} />
}

export const Route = createFileRoute(
  '/_authenticated/_explore/loop/$contentId',
)({
  staticData: { title: 'Loop' },
  component: LoopPage,
  validateSearch: (search: Record<string, unknown>): { source?: 'library' } => ({
    source: search.source === 'library' ? 'library' : undefined,
  }),
})
